import axios from 'axios';
import { useEffect, useState } from 'react';

export const useData = (url, setError) => {
	const [data, setData] = useState(null);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await axios.get(url);
				setData(response.data);
			} catch (err) {
				console.error('Error fetching app data:', err);
				// TODO: Make sure to handle the error without accessing properties of undefined
				setError('loading_app_data');
			} finally {
				setLoading(false);
			}
		};

		fetchData();
	}, []);

	return { data, loading };
};
